import { Component, Injector } from '@angular/core';
import { ToolingOperatorService } from '../../ve.service';
import { BaseGridComponent } from '../base-grid/base-grid.component';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { Validators } from '@angular/forms';
import { FilterableService } from '../../../../shared/filterable-service';

@Component({
  selector: 'app-tooling-operator-interfaces',
  templateUrl: '../base-grid/base-grid.component.html',
})
export class ToolingOperatorInterfacesComponent extends BaseGridComponent {
  public descMaxLength: number = null;
  public displayOrderMax: number = null;
  private readonly categoryFilterableService = new FilterableService();

  constructor(
    cgpConfirmationDialogService: CgpConfirmationDialogService,
    cgpSnackbarService: CgpSnackbarService,
    service: ToolingOperatorService,
    injector: Injector,
  ) {
    super(cgpConfirmationDialogService, cgpSnackbarService, service, injector);
    this.descMaxLength = 100;
    this.displayOrderMax = 5;
    this.appCardTitle = 'Tooling Operator Interfaces';
    this.path = '/?activeOnly=false';

    this.columns = [
      {
        field: 'Description',
        title: 'Description',
      },
      {
        field: 'Category',
        title: 'Category',
        type: 'dropdown',
        service: this.categoryFilterableService,
        name: 'Category',
        refreshSecondaryData: this.populateCategoryList,
      },
      {
        field: 'DisplayOrder',
        title: 'Display Order',
        editor: 'number',
        filter: 'numeric'
      },
      {
        field: 'IsActive',
        title: 'Active',
        editor: 'boolean',
        filter: 'boolean'
      },
    ];

    this.editForm = this.formBuilder.group({
      Id: [],
      Description: ['', Validators.required],
      Category: ['', Validators.required],
      DisplayOrder: ['', Validators.compose([Validators.required, Validators.pattern('[0-9]*'), Validators.max(99999)])],
      IsActive: [],
      AuditDto: []
    });
  }

  populateCategoryList(dataItem: any) {
    const categoryList: any[] = ['Operator', 'Tooling/Product'];
    categoryList.sort();
    dataItem.categoryFilterableService.next(categoryList);
  }
}
